import { RouteReuseStrategy, Data, OutletContext } from '@angular/router';
import { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { ComponentRef, Injectable } from '@angular/core';

interface IRouteStorageObject {
  snapshot: ActivatedRouteSnapshot;
  handle: any;
}

@Injectable()
export class CacheRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes: { [key: string]: IRouteStorageObject } = {};
  private allowRetriveCache = {
    'line-items': true,
    inspection: true,
    'vehicle-condition-report': true,
    dashboard: true,
    menu: true,
    'vehicle/:id': true,
    'service-schedule': true,
  };
  // decides if the route should be stored
  public shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return !!this.getRouteReuseHashIfReusable(route);
  }

  // store the info for the route being destructed in an object of type `IRouteStorageObject` to attach later
  public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const routeHash = this.getRouteReuseHashIfReusable(route);
    if (!routeHash) {
      return;
    }

    let storedRoute: IRouteStorageObject = {
      snapshot: route,
      handle: handle,
    };

    this.storedRoutes[routeHash] = storedRoute;
    console.log(this.storedRoutes);
  }

  // decides if the route should be reattached
  public shouldAttach(route: ActivatedRouteSnapshot): boolean {
    let self = this;
    if (!this.allowRetriveCache.hasOwnProperty(route.routeConfig.path)) {
      for (const key in this.storedRoutes) {
        if (this.storedRoutes[key].handle != null) {
          this.deactivateOutlet(this.storedRoutes[key].handle);
        }
      }
      this.storedRoutes = {};
    }
    const routeHash = this.getRouteReuseHashIfReusable(route);
    if (!routeHash) {
      return false;
    }

    const storedRoute = this.storedRoutes[routeHash];
    return !!(storedRoute && storedRoute.handle);
  }

  // if shouldAttach, return the actual route data for restoration
  public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    const routeHash = this.getRouteReuseHashIfReusable(route);

    const storedRoute = routeHash && this.storedRoutes[routeHash];
    return storedRoute ? storedRoute.handle : null;
  }

  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Default angular routeReuseStrategy behaviour
    return future.routeConfig === curr.routeConfig;
  }

  private getRouteReuseHashIfReusable(route: ActivatedRouteSnapshot): string | null {
    const data = this.getRouteAndChildrenData(route);
    return data ? JSON.stringify(data) : null;
  }

  private getRouteAndChildrenData(route: ActivatedRouteSnapshot): Data | null {
    let data = route.data;
    // console.log(`ayy data`);
    // console.log(data);
    if (!data.shouldReuseRoute) {
      return null;
    }

    let currentRoute = route.firstChild;
    while (currentRoute) {
      data = {
        ...data,
        ...currentRoute.data,
        feature: {
          ...data.feature,
          ...currentRoute.data.feature,
        },
      };

      currentRoute = currentRoute.firstChild;
    }

    return data.shouldReuseRoute ? data : null;
  }

  private deactivateOutlet(handle: any): void {
    const componentRef: ComponentRef<any> = handle['componentRef'];
    if (componentRef) {
      componentRef.destroy();
    }
  }
}

// export class CacheRouteReuseStrategy implements RouteReuseStrategy {
//   handlers: { [key: string]: DetachedRouteHandle } = {};
//   allowRetriveCache = {
//     'line-items': true,
//     inspection: true,
//     'vehicle-condition-report': true,
//     dashboard: true,
//     menu: true,
//     'vehicle/:id': true
//   };
//   public shouldDetach(route: ActivatedRouteSnapshot): boolean {
//     //return route.routeConfig.path === 'purchase';
//     const path = this.getPath(route);
//     console.log('should detatch');
//     console.log(path);
//     if (this.allowRetriveCache.hasOwnProperty(path)) {
//       return true;
//     }
//     return false;
//   }

//   // store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
//   //   this.handlers[route.url.join('/') || route.parent.url.join('/')] = handle;
//   // }

//   shouldAttach(route: ActivatedRouteSnapshot): boolean {
//     return !!this.handlers[route.url.join('/') || route.parent.url.join('/')];
//   }

//   retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
//     return this.handlers[route.url.join('/') || route.parent.url.join('/')];
//   }

//   shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
//     return future.routeConfig === curr.routeConfig;
//   }

//   private getKey(route: ActivatedRouteSnapshot): string {
//     return route.pathFromRoot
//       .map((el: ActivatedRouteSnapshot) => (el.routeConfig ? el.routeConfig.path : ''))
//       .filter(str => str.length > 0)
//       .join('');
//   }

//   store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
//     this.handlers[this.getKey(route)] = handle;
//   }

//   // public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
//   //   // console.log(`storing route for path ${route.routeConfig.path}`);
//   //   //console.log(handle);
//   //   this.handlers[route.routeConfig.path] = handle;
//   //   // if (route.routeConfig.path == 'menu'){
//   //   //   this.handlers['vehicle/:id']
//   //   // }
//   //   //console.log(this.handlers);
//   // }
//   // public shouldAttach(route: ActivatedRouteSnapshot): boolean {
//   //   console.log('should attach');
//   //   console.log(this.getPath(route));
//   //   if (!this.allowRetriveCache.hasOwnProperty(route.routeConfig.path)) {
//   //     //console.log('clearing handlers');
//   //     this.handlers = {};
//   //   }
//   //   return !!route.routeConfig && !!this.handlers[route.routeConfig.path];
//   // }

//   // /** Retrieves the previously stored route */
//   // public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
//   //   if (!route.routeConfig) {
//   //     return null;
//   //   }
//   //   //console.log(this.handlers);
//   //   return this.handlers[
//   //     route.routeConfig.path == 'vehicle/:id' ? route.parent.routeConfig.path : route.routeConfig.path
//   //   ];
//   // }
//   // public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
//   //   return future.routeConfig === curr.routeConfig || future.data.reuse;
//   // }

//   private getPath(route: ActivatedRouteSnapshot): string {
//     if (route.routeConfig !== null && route.routeConfig.path !== null) {
//       return route.routeConfig.path;
//     }
//     return '';
//   }
// }
